module.exports = __webpack_public_path__ + "img/principal_aulasextras.c6b66bc6.png";